// extracted by mini-css-extract-plugin
export default {"add_approver_cell":"AddApproverCell_add_approver_cell__RnkPZ","select_approver_wrapper":"AddApproverCell_select_approver_wrapper__aIre7","icon":"AddApproverCell_icon__W7dtc"};